module.exports = __webpack_public_path__ + "static/media/Android.39a49886.svg";